module.exports = __webpack_public_path__ + "img/blue-square-table-4.f7377e0a.png";